import { sessionHash } from '../threecube/sessionHash'
export const server = ({ host: sessionServer }) => ({
  async join(accessToken, selectedProfile, serverId, sharedSecret, publicKey, callback) {
    try {
      const hash = await sessionHash(serverId, sharedSecret, publicKey)
      const response = await fetch(`${sessionServer.replace(/\/$/, '')}/session/minecraft/join`, {
        method: 'POST', headers: {'Content-Type':'application/json'},
        body: JSON.stringify({accessToken,selectedProfile,serverId:hash}),
      })
      if (!response.ok) throw new Error(`Minecraft session authorization failed (${response.status})`)
      callback(null)
    } catch (error) { callback(error) }
  },
})
